import BaseService from "../../base/base_service";
import FullScreenTapContainerController from "../../components/full_screen/full_screen_tap_container_controller";
import NetEntGameBodyComponent from '../company_selector/companies/netent/components/netent_gamebody_component';

export default class ComponentFactoryService extends BaseService {
    static CLASS = 'ComponentFactoryService';

    createComponent(componentPrototype, params) {
        return componentPrototype.create(params);
    }

    createFullScreenTapComponent(params){
        return this.createComponent(FullScreenTapContainerController, params);
    }

    createNetEntGameBodyComponent(params) {
        return this.createComponent(NetEntGameBodyComponent, params);
    }
}
